import GlobalStyle from '@components/GlobalStyles';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import { ErrorBoundary } from 'react-error-boundary';

import { AppContextProvider } from '@store/context';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { CompanyInterface } from '@interfaces/CompanyInterface';
import { features } from './features';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export const CompanyEvaluating = ({ feature = 'evaluating' }: CompanyInterface) => {
  const fallbackRender = (): JSX.Element => null;

  return (
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <ThemeProvider theme={dsTokens}>
          <ErrorBoundary fallbackRender={fallbackRender}>
            <GlobalStyle />
            {features[feature as keyof typeof features]}
          </ErrorBoundary>
        </ThemeProvider>
      </AppContextProvider>
    </QueryClientProvider>
  );
};

export default CompanyEvaluating;
